import { I18n } from "react-redux-i18n";

export const toTranslatedLabelValue = (it: string) => {
  return {
    label: I18n.t(it),
    value: it,
  };
};
